export enum ExperimentStatus {
    LIVE = 'LIVE',
    SCHEDULED = 'SCHEDULED',
    PAUSED = 'PAUSED',
    CONCLUDED = 'CONCLUDED',
    ARCHIVED = 'ARCHIVED',
    DELETE = 'DELETE',
}

export const ExperimentStatusIndexes: Record<ExperimentStatus, number> = {
    [ExperimentStatus.LIVE]: 0,
    [ExperimentStatus.SCHEDULED]: 1,
    [ExperimentStatus.PAUSED]: 2,
    [ExperimentStatus.CONCLUDED]: 3,
    [ExperimentStatus.ARCHIVED]: 4,
    [ExperimentStatus.DELETE]: 5,
}

export enum ExperimentGroupingStatus {
    LIVE = 'Live',
    SCHEDULED = 'Scheduled',
    PAUSED = 'Paused',
    CONCLUDED = 'Concluded',
    ARCHIVED = 'Archived',
    ANY = 'Any',
}

export enum ExperimentTypeFilterOptions {
    ALL = 'All',
    STANDARD = 'Standard',
    CAMPAIGN = 'Campaign',
}

export const statusGroupingMapping = {
    [ExperimentStatus.LIVE]: ExperimentGroupingStatus.LIVE,
    [ExperimentStatus.SCHEDULED]: ExperimentGroupingStatus.SCHEDULED,
    [ExperimentStatus.PAUSED]: ExperimentGroupingStatus.PAUSED,
    [ExperimentStatus.CONCLUDED]: ExperimentGroupingStatus.CONCLUDED,
    [ExperimentStatus.ARCHIVED]: ExperimentGroupingStatus.ARCHIVED,
    [ExperimentStatus.DELETE]: ExperimentGroupingStatus.ARCHIVED,
}
